import React from 'react'

import {t} from '@lib/helpers'
import {
  bulletCheckIcon,
  CONTACT_URL,
  html,
  industryImagePositions,
  industryImages,
  PARTNER_AWS_SOLUTION_SECTION_ID,
  zipWithImage,
} from './constant'

export default function Industry() {
  const industries = zipWithImage(
    t('pages.partnerAws.industry.list'),
    industryImages
  )
  const [openIndex, openIndexSet] = React.useState(0)

  return (
    <section className='PartnerAws__industry'>
      <div className='PartnerAws__inner PartnerAws__industry__top'>
        <div className='PartnerAws__industry__text'>
          <p className='PartnerAws__caption PartnerAws__gradient-text'>
            {t('pages.partnerAws.industry.caption')}
          </p>
          <h2 className='PartnerAws__section-title'>
            {t('pages.partnerAws.industry.titleLine1')}
            <br />
            {t('pages.partnerAws.industry.titleLine2')}
          </h2>
          <p
            className='PartnerAws__industry__description'
            {...html(t('pages.partnerAws.industry.description'))}
          />

          <div className='PartnerAws__industry__cta'>
            <a
              className='PartnerAws__button PartnerAws__button--gradient'
              href={`#${PARTNER_AWS_SOLUTION_SECTION_ID}`}
            >
              {t('pages.partnerAws.industry.primaryButton')}
            </a>
            <a
              className='PartnerAws__button PartnerAws__button--primary'
              href={CONTACT_URL}
            >
              {t('pages.partnerAws.industry.secondaryButton')}
            </a>
          </div>
        </div>

        <div className='PartnerAws__industry__accordions'>
          {industries.map((industry, index) => {
            const expanded = openIndex === index

            return (
              <div
                className={`PartnerAws__industry__accordion${
                  expanded ? ' is-expanded' : ''
                }`}
                key={index}
              >
                <button
                  className='PartnerAws__industry__accordion__summary'
                  type='button'
                  aria-expanded={expanded}
                  onClick={() => openIndexSet(expanded ? -1 : index)}
                >
                  <span>{industry.name}</span>
                  <svg viewBox='0 0 24 24' aria-hidden='true'>
                    <path
                      d='M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z'
                      fill='currentColor'
                    />
                  </svg>
                </button>

                <div
                  className='PartnerAws__industry__accordion__panel'
                  aria-hidden={!expanded}
                >
                  <div className='PartnerAws__industry__accordion__details'>
                    {(industry.benefits || []).map((benefit, benefitIndex) => (
                      <div
                        className='PartnerAws__industry__benefit'
                        key={benefitIndex}
                      >
                        <img src={bulletCheckIcon} alt='' />
                        <div>
                          <h3 className='PartnerAws__industry__benefit__title'>
                            {benefit.title}
                          </h3>
                          <p className='PartnerAws__industry__benefit__description'>
                            {benefit.description}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div className='PartnerAws__inner PartnerAws__industry__cards'>
        {industries.map((industry, index) => (
          <div className='PartnerAws__industry__card' key={index}>
            {!!industry.image && (
              <img
                src={industry.image}
                alt={industry.name}
                style={{
                  objectPosition: industryImagePositions[index] || 'center',
                }}
              />
            )}
            <h3 className='PartnerAws__industry__card__title'>
              {industry.name}
            </h3>
          </div>
        ))}
      </div>
    </section>
  )
}
